<template>
  <div class="form-group row">
    <label class="col-sm-2 col-form-label" :class="{'text-info': hasValue}" :for="'filter_' + fieldKey">{{ fieldName }}:</label>

    <div class="col-sm-2">
      <select v-model="operator" :name="'operator_' + fieldKey" class="form-control">
        <option v-for="op in Object.entries(operatorOptions)" :value="op[0]">{{ op[1] }}</option>
      </select>
    </div>

    <div class="col-sm-8">
      <component :is="widgetName" v-bind="widgetProps" :field-key="fieldKey" :field-value="fieldValue" :operator="operator"></component>
    </div>
  </div>
</template>

<script>
import BaseFilterWidgetText from "./type-widgets/BaseFilterWidgetText.vue";
import BaseFilterWidgetPhone from "./type-widgets/BaseFilterWidgetPhone.vue";
import BaseFilterWidgetNumeric from "./type-widgets/BaseFilterWidgetNumeric.vue";
import BaseFilterWidgetDate from "./type-widgets/BaseFilterWidgetDate.vue";
import BaseFilterWidgetLookup from "./type-widgets/BaseFilterWidgetLookup.vue";

import ClaimFilterWidgetTask from "./custom-widgets/ClaimFilterWidgetTask.vue";
import ClaimFilterWidgetDeploymentStatus from "./custom-widgets/ClaimFilterWidgetDeploymentStatus.vue";
import ClaimFilterWidgetFollowup from "./custom-widgets/ClaimFilterWidgetFollowup.vue";
import ClaimFilterWidgetExperiences from "./custom-widgets/ClaimFilterWidgetExperiences.vue";

export default {

  components: {
    'base-filter-widget-text': BaseFilterWidgetText,
    'base-filter-widget-phone': BaseFilterWidgetPhone,
    'base-filter-widget-numeric': BaseFilterWidgetNumeric,
    'base-filter-widget-date': BaseFilterWidgetDate,
    'base-filter-widget-lookup': BaseFilterWidgetLookup,

    'claim-filter-widget-task': ClaimFilterWidgetTask,
    'claim-filter-widget-deployment-status': ClaimFilterWidgetDeploymentStatus,
    'claim-filter-widget-followup': ClaimFilterWidgetFollowup,
    'claim-filter-widget-experiences': ClaimFilterWidgetExperiences,
  },

  props: {
    fieldKey: {type: String, required: true},
    fieldName: {type: String, required: true},
    fieldValue: {type: [String, Array, Object], default: ''},

    initialOperator: {type: String, required: true},
    operatorOptions: {type: Object, default: function () { return {} }},

    widgetName: {type: String, required: true},
    widgetProps: {type: Object, default: function () { return {} }},
  },

  data () {
    return {
      operator: this.initialOperator,
    }
  },

  computed: {

    hasValue() {
      if (this.initialOperator === 'not_empty') return true;
      return (this.fieldValue !== null) && (this.fieldValue !== '') && (this.fieldValue !== []);
    }

  },

}
</script>
